import type { CtaProps } from "@/types/components/p2p-money-abroad/cta"
import type { FC } from "react"
import NextImage from "next/image";
import { ContentManager } from "../content-manager"
import { Link } from "../link";

export const CTA: FC<CtaProps> = ({
  cta
}) => {

  return (
    <section className="wrapper wrapper_lg p2pMoneyAbroad">
      <div className="cta p2pMoneyAbroad--cta">
        <div className="cta--inner">
          {cta.text && (
            <ContentManager content={cta.text} className="cta--text" />
          )}
          <button
            className="link link_white link_full cta--link learn-more"
            onClick={() => {

            }}
            data-title={cta.buttonLabel}
          >
            <Link
              href={'https://www.mastercard.com/news/press/2023/april/mastercard-s-cross-border-services-express-helps-modernize-international-payments/'}
              target="_blank"
              theme="white"
              fill="full"
              title={cta.buttonLabel}
              className="cta--link"
            >
            <span>{cta.buttonLabel}</span>
          </Link>
          </button>
          
        </div>
        <NextImage
          src="/images/spiral-2.webp"
          alt="Spiral"
          width={1417}
          height={1653}
          role="presentation"
          draggable={false}
          className="cta--spiral"
        />
      </div>
    </section>
  )
}